<ng-container
    *appHasPermissionId="
        type === 'kpi-result'
            ? permissionList.kpiResultEntry
            : permissionList.kpiResultFlow
    "
>
    @if (mode !== 'view') {
        <div class="mb-3 flex justify-end">
            <button
                (click)="showCreateCapabilityDialog()"
                class="btn btn-sm btn-white"
            >
                <i class="fa-light fa-plus"></i>
                {{ 'translate_add_new' | translate }}
            </button>
        </div>
    }
</ng-container>

<app-list-loading
    [items]="items"
    class="d-block"
    [loadingClasses]="'text-center text-primary h4 d-block font-weight-bold'"
    [loadingStyles]="{ fontSize: '1.2rem' }"
    [itemsAreUnavailableClasses]="'text-center text-muted h4 d-block'"
>
    <div class="overflow-hidden rounded-2xl border border-slate-200 bg-white">
        <div class="table-responsive">
            <table>
                <thead>
                    <tr>
                        <th>{{ 'translate_capability' | translate }}</th>
                        <th>{{ 'translate_description' | translate }}</th>
                        <th>
                            {{ 'translate_type' | translate }}
                        </th>
                        <ng-container
                            *appHasPermissionId="
                                type === 'kpi-result'
                                    ? permissionList.kpiResultEntry
                                    : permissionList.kpiResultFlow
                            "
                        >
                            <th></th>
                        </ng-container>
                    </tr>
                </thead>

                <tbody>
                    @for (item of items; track item) {
                        <tr>
                            <td>
                                {{ item.name }}
                            </td>
                            <td>
                                {{ item.description }}
                            </td>
                            <td>
                                {{ item.type.name }}
                            </td>
                            <ng-container
                                *appHasPermissionId="
                                    type === 'kpi-result'
                                        ? permissionList.kpiResultEntry
                                        : permissionList.kpiResultFlow
                                "
                            >
                                <td>
                                    <div class="flex flex-nowrap items-center">
                                        <!-- Edit capability -->
                                        @if (mode !== 'view') {
                                            <button
                                                (click)="
                                                    showCreateCapabilityDialog(
                                                        item.id
                                                    )
                                                "
                                                [appTooltip]="
                                                    'translate_edit' | translate
                                                "
                                                class="action-icon action-icon-edit me-2"
                                            >
                                                <i class="fa-light fa-edit"></i>
                                            </button>
                                        }
                                        <!-- Link file  -->
                                        <button
                                            (click)="showLinkedLibrary(item)"
                                            [appTooltip]="
                                                'translate_attachments'
                                                    | translate
                                            "
                                            class="action-icon action-icon-primary me-2"
                                        >
                                            <i
                                                class="fa-light fa-paperclip"
                                            ></i>
                                        </button>
                                        <!-- Delete -->
                                        @if (mode !== 'view') {
                                            <app-delete-button
                                                [isDisabled]="
                                                    currentlyDeleting.includes(
                                                        item.id
                                                    )
                                                "
                                                (delete)="delete(item)"
                                                [itemName]="
                                                    item.capability.name
                                                "
                                                [appTooltip]="
                                                    'translate_delete'
                                                        | translate
                                                "
                                            ></app-delete-button>
                                        }
                                    </div>
                                </td>
                            </ng-container>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
</app-list-loading>
